import FastMarquee from "react-fast-marquee";

const WORDS = ["Confidence", "Charisma", "Presence", "Transformation", "Abundance", "Masculinity"];

export default function Marquee() {
  return (
    <div
      className="overflow-hidden border-y border-white/10 py-10 lg:py-14"
      data-testid="editorial-marquee"
    >
      <FastMarquee speed={28} gradient={false}>
        {WORDS.map((w, i) => (
          <span key={w} className="flex items-center">
            <span
              className={`mx-8 font-serif text-6xl font-light italic tracking-tight lg:text-8xl ${
                i % 2 === 0 ? "text-white/90" : "text-outline"
              }`}
            >
              {w}
            </span>
            <span className="h-2 w-2 rounded-full bg-white/30" />
          </span>
        ))}
      </FastMarquee>
    </div>
  );
}
